"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterProjects = exports.ProjectTypes = void 0;
var ProjectTypes;
(function (ProjectTypes) {
    ProjectTypes["PROJECT"] = "project";
    ProjectTypes["SERVICE_ORDER"] = "service-order";
    ProjectTypes["UNKNOWN"] = "unknown";
})(ProjectTypes = exports.ProjectTypes || (exports.ProjectTypes = {}));
/**
 *  Search a project by the properties listed below
 */
var filterProjects = function (projects, searchString) {
    if (!projects || !projects.length) {
        return [];
    }
    var filter = function (property) {
        return property &&
            property.toLowerCase && // In case of number gets in, will fail
            property.toLowerCase().indexOf(searchString.toLowerCase()) !== -1;
    };
    var filterEachProperty = function (project) { return [
        project.name,
    ].some(filter); };
    var results = projects.filter(filterEachProperty);
    return results;
};
exports.filterProjects = filterProjects;
